import { render, staticRenderFns } from "./InternationDrawer.vue?vue&type=template&id=dd618cc0&scoped=true&"
import script from "./InternationDrawer.vue?vue&type=script&lang=js&"
export * from "./InternationDrawer.vue?vue&type=script&lang=js&"
import style0 from "./InternationDrawer.vue?vue&type=style&index=0&id=dd618cc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd618cc0",
  null
  
)

export default component.exports